import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import styles from "./Checkbox.module.css";
import CheckboxCheckedIcon from "../../assets/checkbox-checked.svg";
import CheckboxIcon from "../../assets/checkbox.svg";
import CheckboxDisabledIcon from "../../assets/checkbox-disabled.svg";
import IndeterminateIcon from "../../assets/indeterminate_check_box.svg";
import classNames from "classnames";

export const CHECKBOX_STATES = {
	Checked: true,
	Indeterminate: null,
	Unchecked: false,
};
const getIndeterminateValue = (value: any) => {
	let checked = value;
	if (checked === CHECKBOX_STATES.Checked) {
		checked = CHECKBOX_STATES.Unchecked;
	} else if (checked === CHECKBOX_STATES.Unchecked) {
		checked = CHECKBOX_STATES.Indeterminate;
	} else if (checked == CHECKBOX_STATES.Indeterminate) {
		checked = CHECKBOX_STATES.Checked;
	}
	return checked;
};

const Checkbox = ({
	label,
	defaultValue,
	name,
	onChange,
	disabled,
	className,
	indeterminateEnabled,
	editable = true,
}: any) => {
	const [value, setValue] = useState(defaultValue);
	const handleClick = () => {
		if (disabled || !editable) {
			return;
		}
		if (indeterminateEnabled) {
			const indeterminateValue = getIndeterminateValue(value);
			setValue(indeterminateValue);
			onChange?.({ name, value: indeterminateValue });
		} else {
			setValue((prev: any) => !prev);
			onChange?.({ name, value: !value });
		}
	};
	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	return (
		<div
			onClick={handleClick}
			className={classNames(styles.container, className, {
				[styles.radioDisabled]: disabled,
				[styles.radioNotEditable]: !disabled && !editable,
			})}
		>
			{!indeterminateEnabled ? (
				<img
					draggable="false"
					className={styles.icon}
					src={
						disabled && value
							? CheckboxDisabledIcon
							: value
							? CheckboxCheckedIcon
							: CheckboxIcon
					}
				/>
			) : (
				<>
					<img
						draggable="false"
						className={styles.icon}
						src={
							value == CHECKBOX_STATES.Indeterminate
								? IndeterminateIcon
								: disabled &&
								  value === CHECKBOX_STATES.Unchecked
								? CheckboxDisabledIcon
								: value === CHECKBOX_STATES.Checked
								? CheckboxCheckedIcon
								: CheckboxIcon
						}
					/>
				</>
			)}

			<div
				className={`${styles.label} ${
					disabled ? styles.labelDisabled : ""
				}`}
			>
				{label}
			</div>
		</div>
	);
};
Checkbox.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string,
	defaultValue: PropTypes.any,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	indeterminateEnabled: PropTypes.bool,
	editable: PropTypes.bool,
};
export default Checkbox;
